export default "__VITE_ASSET__DqZ1qamn__"